<template>
    <App :isShow="true">

        <div class="row gx-sm-0 gx-md-5">
            <div class="v-col-sm-12 v-col-md-8 v-col-lg-9 px-4">
                <SubMenu @onSearch="onSearchHandle" :searchShow="true"/>

                <h5 class=" mt-3">{{ article.title }}</h5>

                <span class="text-grey">ផ្សាយ៖ {{ khmerDateFormat(article.created_at) }}</span>
                <hr class="text-grey">
                <div class="detail-body align-items-start justify-content-start" >
                    <div class="justify-content-start" v-if="article.format==='news' || article.format==='others' || article.format==='photos'" v-html="removeCenter(article.body)">

                    </div>

                    <iframe class="pdf"
                           v-if="article.format==='books' || article.format==='documents'"
                           v-for="(pdf, index) in pdfLinks(article.body)"
                           :key="index"
                           :src="pdf"
                           width="90%" style="height: 700px;">
                    </iframe>

                    <div class="other_images row">
                        <div v-for="image in article.other_images" class="image">
                            <iframe v-if="isPDF(image)"
                                :src="getImage(image) + '#toolbar=0'"
                                width="100%"
                                height="700px">
                            </iframe>

                            <!-- <img  v-if="isImage(image)" :src="getImage(image)" :alt="article.title"> -->

                        </div>
                        <div v-for="image in article.other_images" v-if="article.other_images && article.name == 'រូបភាព'" class="v-col-12 v-col-sm-6 v-col-md-6 v-col-lg-4">
                            <v-card @click="onDialogImage(image)" elevation="0" style="height: 200px;"  flat v-if="isImage(image)">
                                <img @click="onDialogImage(image)"  v-if="isImage(image)" :src="getImage(image)"class="rounded w-100 h-100 ma-0" style="object-fit: cover;">
                            </v-card>
                        </div>
                    </div>
                </div>

            </div>
            <div class="v-col-sm-12 v-col-md-4 v-col-lg-3">
                <RightSideBar :relate_news="relate_news"/>
            </div>
            <v-dialog
                v-model="isDialogImage"
                width="650"
            >
                <v-card flat>
                    <v-img :src="getImage(imageUrl)" style="object-fit: cover !important;"></v-img>
                </v-card>
            </v-dialog>
        </div>
     
    </App>
</template>

<script setup>

import App from "../Layouts/App";
import RightSideBar from "../Components/RightSideBar.vue";
import { reactive, ref } from "vue";
import {Link} from '@inertiajs/vue3';
import NewsCardTile from "../Components/NewsCardTile.vue";
import SubMenu from "../Components/Share/SubMenu.vue";
import {Inertia} from "@inertiajs/inertia";
import FloatingAudioPlayer from "../Components/FloatingAudioPlayer.vue";


const props = defineProps({
    article: Object,
    relate_news: Array,
    isShow: Boolean,
});

const isDialogImage = ref(false);
const imageUrl = ref("");
const search = ref('');

async function onSearchHandle(newSearch) {
    search.value = newSearch;
    Inertia.visit('/search/news', {
        method: 'get',
        data: {
            search: newSearch,
        },
        preserveState: true,
        replace: true,
        only: ['countPosts','search','posts','slug'],
    });
}

function onDialogImage(image) {
    isDialogImage.value = true;
    imageUrl.value = image;
}

function pdfLinks(body) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(body, "text/html");

    // Collect all PDF links
    const links = Array.from(doc.querySelectorAll('a[href$=".pdf"]'))
        .map((el) => el.href);

    return links;
}
function audioLinks(body) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(body, "text/html");

    // Collect all PDF links
    const links = Array.from(doc.querySelectorAll('a[href$=".mp3"]'))
        .map((el) => el.href);

    return links;
}
function filteredHtml(body) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(body, "text/html");

    // Remove PDF <a> tags from HTML
    doc.querySelectorAll('a[href$=".pdf"]').forEach((el) => el.remove());
    return doc.body.innerHTML;
}
function isImage(file) {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(file);
}
function isPDF(file) {
    return /\.pdf$/i.test(file);
}

</script>


